export const EXTERNAL_READ_REQUEST = "EXTERNAL_READ_REQUEST";
export const EXTERNAL_READ = "EXTERNAL_READ";
